import React from "react";
import styles from "./StickyActionBar.module.css";

export interface StickyActionBarProps {
  children: React.ReactNode;
  error?: string;
}

/**
 * Pinned footer for page-level actions (e.g. Cancel / Create).
 *
 * Sticks to the bottom of the viewport on scroll. An optional `error` is
 * shown at the leading edge in the Astryx danger color — Astryx's Text
 * component doesn't expose an error/danger color variant in this theme
 * build, so the message is rendered as plain text styled directly with the
 * `--color-error` token via the CSS module.
 */
const StickyActionBar = ({
  children,
  error,
}: StickyActionBarProps): React.ReactElement => {
  return (
    <footer className={styles.bar}>
      <div className={styles.inner}>
        {error && (
          <p className={styles.error} role="alert">
            {error}
          </p>
        )}
        <div className={styles.actions}>{children}</div>
      </div>
    </footer>
  );
};

export default StickyActionBar;
